import React from 'react';
import PropTypes from 'prop-types';
import DollarSign from 'components/ui/icons/DollarSign';
import TimerFilled from 'components/ui/icons/TimerFilled';
import TimerHalf from 'components/ui/icons/TimerHalf';
import { IconWrapper } from './styles';

const Compensation = ({ isFullTime, projectType, compensation }) => {
  const ProjectTypeIcon = () => {
    return isFullTime ? <TimerFilled width="15" /> : <TimerHalf width="15" />;
  };

  return (
    <div className="job_type">
      <IconWrapper>
        <ProjectTypeIcon />
      </IconWrapper>
      {projectType}
      <div className="job_budget font-bold mb-2 d-flex">
        <IconWrapper>
          <DollarSign width="15" />
        </IconWrapper>
        {compensation}
      </div>
    </div>
  );
};

Compensation.propTypes = {
  compensation: PropTypes.string,
  isFullTime: PropTypes.bool,
  projectType: PropTypes.string,
};

export default Compensation;
